// import {
//   Info as Icon
// } from 'components/icons';

import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="location arrow" {...props} />;
  // return <Icon name="tags" {...props} />;
}

export const meta = {
  id: 'CMSPAGESCATEGORIESDetails',
  title: 'CMSPAGESCATEGORIESDetails',
  category: 'CMSPAGES',
  unique: false,
  icon: TheIcon,
  version: '1.0.0',
  description: `A category used by the CMS`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    width: 420,
    height: 465
  }
};
